var map = {
	"./": [
		3774,
		9
	],
	"./animation-19dbf9bf": [
		7434,
		9
	],
	"./animation-19dbf9bf.js": [
		7434,
		9
	],
	"./app-globals-612de9cd": [
		327,
		9,
		327
	],
	"./app-globals-612de9cd.js": [
		327,
		9,
		327
	],
	"./button-active-80cd2e37": [
		1823,
		9,
		1823
	],
	"./button-active-80cd2e37.js": [
		1823,
		9,
		1823
	],
	"./cubic-bezier-154a53a5": [
		3544,
		9
	],
	"./cubic-bezier-154a53a5.js": [
		3544,
		9
	],
	"./dir-e8b767a8": [
		5213,
		9,
		5213
	],
	"./dir-e8b767a8.js": [
		5213,
		9,
		5213
	],
	"./dom-d6780ec4": [
		8401,
		7,
		8401
	],
	"./dom-d6780ec4.js": [
		8401,
		7,
		8401
	],
	"./focus-visible-02bf7a99": [
		4008,
		9,
		4008
	],
	"./focus-visible-02bf7a99.js": [
		4008,
		9,
		4008
	],
	"./framework-delegate-0e9f0224": [
		6161,
		9,
		6161
	],
	"./framework-delegate-0e9f0224.js": [
		6161,
		9,
		6161
	],
	"./gesture-controller-68c023a4": [
		4988,
		9
	],
	"./gesture-controller-68c023a4.js": [
		4988,
		9
	],
	"./haptic-9a9aa7ec": [
		5310,
		9,
		5310
	],
	"./haptic-9a9aa7ec.js": [
		5310,
		9,
		5310
	],
	"./hardware-back-button-ace6a71b": [
		7292,
		9
	],
	"./hardware-back-button-ace6a71b.js": [
		7292,
		9
	],
	"./helpers-6e1e5b65": [
		7504,
		9
	],
	"./helpers-6e1e5b65.js": [
		7504,
		9
	],
	"./index": [
		3774,
		9
	],
	"./index-41bf41f2": [
		3876,
		9
	],
	"./index-41bf41f2.js": [
		3876,
		9
	],
	"./index-b3eecb14": [
		2896,
		9
	],
	"./index-b3eecb14.js": [
		2896,
		9
	],
	"./index-c841c933": [
		8186,
		9
	],
	"./index-c841c933.js": [
		8186,
		9
	],
	"./index-cdb1cf94": [
		114,
		9
	],
	"./index-cdb1cf94.js": [
		114,
		9
	],
	"./index-e3f61316": [
		5231,
		9,
		5231
	],
	"./index-e3f61316.js": [
		5231,
		9,
		5231
	],
	"./index-e6c2c822": [
		2032,
		9
	],
	"./index-e6c2c822.js": [
		2032,
		9
	],
	"./index.js": [
		3774,
		9
	],
	"./input-shims-61232da0": [
		5542,
		9,
		5542
	],
	"./input-shims-61232da0.js": [
		5542,
		9,
		5542
	],
	"./ion-accordion_2.entry": [
		5102,
		9,
		5102
	],
	"./ion-accordion_2.entry.js": [
		5102,
		9,
		5102
	],
	"./ion-action-sheet.entry": [
		8451,
		9,
		8451
	],
	"./ion-action-sheet.entry.js": [
		8451,
		9,
		8451
	],
	"./ion-alert.entry": [
		8550,
		9,
		8550
	],
	"./ion-alert.entry.js": [
		8550,
		9,
		8550
	],
	"./ion-app_8.entry": [
		1006,
		9,
		1006
	],
	"./ion-app_8.entry.js": [
		1006,
		9,
		1006
	],
	"./ion-avatar_3.entry": [
		9169,
		9,
		9169
	],
	"./ion-avatar_3.entry.js": [
		9169,
		9,
		9169
	],
	"./ion-back-button.entry": [
		9112,
		9,
		9112
	],
	"./ion-back-button.entry.js": [
		9112,
		9,
		9112
	],
	"./ion-backdrop.entry": [
		9389,
		9,
		9389
	],
	"./ion-backdrop.entry.js": [
		9389,
		9,
		9389
	],
	"./ion-breadcrumb_2.entry": [
		8249,
		9,
		8249
	],
	"./ion-breadcrumb_2.entry.js": [
		8249,
		9,
		8249
	],
	"./ion-button_2.entry": [
		7733,
		9,
		7733
	],
	"./ion-button_2.entry.js": [
		7733,
		9,
		7733
	],
	"./ion-card_5.entry": [
		2011,
		9,
		2011
	],
	"./ion-card_5.entry.js": [
		2011,
		9,
		2011
	],
	"./ion-checkbox.entry": [
		3562,
		9,
		3562
	],
	"./ion-checkbox.entry.js": [
		3562,
		9,
		3562
	],
	"./ion-chip.entry": [
		2185,
		9,
		2185
	],
	"./ion-chip.entry.js": [
		2185,
		9,
		2185
	],
	"./ion-col_3.entry": [
		7478,
		9,
		7478
	],
	"./ion-col_3.entry.js": [
		7478,
		9,
		7478
	],
	"./ion-datetime_3.entry": [
		9440,
		9,
		9440
	],
	"./ion-datetime_3.entry.js": [
		9440,
		9,
		9440
	],
	"./ion-fab_3.entry": [
		6608,
		9,
		6608
	],
	"./ion-fab_3.entry.js": [
		6608,
		9,
		6608
	],
	"./ion-img.entry": [
		8014,
		9,
		8014
	],
	"./ion-img.entry.js": [
		8014,
		9,
		8014
	],
	"./ion-infinite-scroll_2.entry": [
		6270,
		9,
		6270
	],
	"./ion-infinite-scroll_2.entry.js": [
		6270,
		9,
		6270
	],
	"./ion-input.entry": [
		2865,
		9,
		2865
	],
	"./ion-input.entry.js": [
		2865,
		9,
		2865
	],
	"./ion-item-option_3.entry": [
		964,
		9,
		964
	],
	"./ion-item-option_3.entry.js": [
		964,
		9,
		964
	],
	"./ion-item_8.entry": [
		7419,
		9,
		7419
	],
	"./ion-item_8.entry.js": [
		7419,
		9,
		7419
	],
	"./ion-loading.entry": [
		966,
		9,
		9740
	],
	"./ion-loading.entry.js": [
		966,
		9,
		9740
	],
	"./ion-menu_3.entry": [
		9936,
		9,
		9936
	],
	"./ion-menu_3.entry.js": [
		9936,
		9,
		9936
	],
	"./ion-modal.entry": [
		3731,
		9,
		3731
	],
	"./ion-modal.entry.js": [
		3731,
		9,
		3731
	],
	"./ion-nav_2.entry": [
		4288,
		9,
		4288
	],
	"./ion-nav_2.entry.js": [
		4288,
		9,
		4288
	],
	"./ion-picker-column-internal.entry": [
		3064,
		9,
		3064
	],
	"./ion-picker-column-internal.entry.js": [
		3064,
		9,
		3064
	],
	"./ion-picker-internal.entry": [
		5472,
		9,
		5472
	],
	"./ion-picker-internal.entry.js": [
		5472,
		9,
		5472
	],
	"./ion-popover.entry": [
		6560,
		9,
		6560
	],
	"./ion-popover.entry.js": [
		6560,
		9,
		6560
	],
	"./ion-progress-bar.entry": [
		5051,
		9,
		5051
	],
	"./ion-progress-bar.entry.js": [
		5051,
		9,
		5051
	],
	"./ion-radio_2.entry": [
		2932,
		9,
		2932
	],
	"./ion-radio_2.entry.js": [
		2932,
		9,
		2932
	],
	"./ion-range.entry": [
		6074,
		9,
		6074
	],
	"./ion-range.entry.js": [
		6074,
		9,
		6074
	],
	"./ion-refresher_2.entry": [
		8290,
		9,
		8290
	],
	"./ion-refresher_2.entry.js": [
		8290,
		9,
		8290
	],
	"./ion-reorder_2.entry": [
		3479,
		9,
		3479
	],
	"./ion-reorder_2.entry.js": [
		3479,
		9,
		3479
	],
	"./ion-ripple-effect.entry": [
		4905,
		9,
		4905
	],
	"./ion-ripple-effect.entry.js": [
		4905,
		9,
		4905
	],
	"./ion-route_4.entry": [
		5095,
		9,
		5095
	],
	"./ion-route_4.entry.js": [
		5095,
		9,
		5095
	],
	"./ion-searchbar.entry": [
		7421,
		9,
		7421
	],
	"./ion-searchbar.entry.js": [
		7421,
		9,
		7421
	],
	"./ion-segment_2.entry": [
		3806,
		9,
		3806
	],
	"./ion-segment_2.entry.js": [
		3806,
		9,
		3806
	],
	"./ion-select_3.entry": [
		6306,
		9,
		6306
	],
	"./ion-select_3.entry.js": [
		6306,
		9,
		6306
	],
	"./ion-slide_2.entry": [
		4208,
		9,
		4208
	],
	"./ion-slide_2.entry.js": [
		4208,
		9,
		4208
	],
	"./ion-spinner.entry": [
		3046,
		9,
		3046
	],
	"./ion-spinner.entry.js": [
		3046,
		9,
		3046
	],
	"./ion-split-pane.entry": [
		4774,
		9,
		4774
	],
	"./ion-split-pane.entry.js": [
		4774,
		9,
		4774
	],
	"./ion-tab-bar_2.entry": [
		3196,
		9,
		3196
	],
	"./ion-tab-bar_2.entry.js": [
		3196,
		9,
		3196
	],
	"./ion-tab_2.entry": [
		3965,
		9,
		3965
	],
	"./ion-tab_2.entry.js": [
		3965,
		9,
		3965
	],
	"./ion-text.entry": [
		2516,
		9,
		2516
	],
	"./ion-text.entry.js": [
		2516,
		9,
		2516
	],
	"./ion-textarea.entry": [
		2117,
		9,
		2117
	],
	"./ion-textarea.entry.js": [
		2117,
		9,
		2117
	],
	"./ion-toast.entry": [
		4617,
		9,
		4617
	],
	"./ion-toast.entry.js": [
		4617,
		9,
		4617
	],
	"./ion-toggle.entry": [
		9125,
		9,
		9125
	],
	"./ion-toggle.entry.js": [
		9125,
		9,
		9125
	],
	"./ion-virtual-scroll.entry": [
		9480,
		9,
		9480
	],
	"./ion-virtual-scroll.entry.js": [
		9480,
		9,
		9480
	],
	"./ionic": [
		1652,
		9,
		1652
	],
	"./ionic-global-0ebe321c": [
		5001,
		9
	],
	"./ionic-global-0ebe321c.js": [
		5001,
		9
	],
	"./ionic.js": [
		1652,
		9,
		1652
	],
	"./ios.transition-8b6a776a": [
		8360,
		9
	],
	"./ios.transition-8b6a776a.js": [
		8360,
		9
	],
	"./keyboard-808e4e15": [
		5820,
		9,
		5820
	],
	"./keyboard-808e4e15.js": [
		5820,
		9,
		5820
	],
	"./loader": [
		823,
		9,
		823
	],
	"./loader.js": [
		823,
		9,
		823
	],
	"./md.transition-da866119": [
		2782,
		9
	],
	"./md.transition-da866119.js": [
		2782,
		9
	],
	"./overlays-36d3475d": [
		6250,
		9
	],
	"./overlays-36d3475d.js": [
		6250,
		9
	],
	"./spinner-configs-163ed7fb": [
		5348,
		9,
		4664
	],
	"./spinner-configs-163ed7fb.js": [
		5348,
		9,
		4664
	],
	"./status-tap-3ed8ecec": [
		7563,
		9,
		7563
	],
	"./status-tap-3ed8ecec.js": [
		7563,
		9,
		7563
	],
	"./swipe-back-f65c5686": [
		213,
		9,
		5905
	],
	"./swipe-back-f65c5686.js": [
		213,
		9,
		5905
	],
	"./swiper.bundle-28080340": [
		1147,
		9,
		1147
	],
	"./swiper.bundle-28080340.js": [
		1147,
		9,
		1147
	],
	"./tap-click-a895802b": [
		9952,
		9,
		9952
	],
	"./tap-click-a895802b.js": [
		9952,
		9,
		9952
	],
	"./theme-a24ff1ad": [
		9491,
		9,
		9491
	],
	"./theme-a24ff1ad.js": [
		9491,
		9,
		9491
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 3076;
module.exports = webpackAsyncContext;